import React,{useState,useEffect,useCallback,useRef,useImperativeHandle} from 'react'
import {Toast } from 'antd-mobile'
import instance from '../../utils/req';
import style from './oderInfo.module.css'
import ZFB from '../../assets/img/支付宝支付.png'
import WX from '../../assets/img/微信支付.png'
import payCheckOff from '../../assets/img/check2Off.png'
import payCheckOn from '../../assets/img/check2On.png'
import { useHistory } from "react-router-dom";
import { iswx, iszfb, computePX } from '../../utils/tool';
import {PAY} from '../../utils/config'


// 选择支付组件
const PayItem = (props) => {
  return (
    <div className={style.payItem} onClick={()=>{props.onClick()}}>
    <div className={style.payLogo}>
      <img src={props.img} alt={props.name} className={style.payImg}/>
      <span>{props.name}</span>
    </div>
    <div className={style.payCheck}>
      <img src={props.checked?payCheckOn:payCheckOff} alt="支付"/>
    </div>
  </div>
  )
}
// 获取servicestoken
function useGetServicestoken(member_id) {
  return useCallback(async () => {
    return ''
    /* if (member_id === undefined) return
    let data = await instance({
      method:'post',
      url:'http://api.caixuetang.cn/index.php?c=cxtService&a=getServiceToken&vcxt=2.0',
      data:{
        member_id,
        key:localStorage.getItem('key'),
        client_type: 'h5',
      }
    })
    if (data.code !== 1) {
      Toast.fail(data.message)
      return
    }
    return data.data */
  },[member_id])
}
// 获取商品详情
function useGetGoodsInfo(member_id, sku_id) {
  return useCallback(async (servicestoken) => {
    // let goods_id = route.location.search
    if (member_id === undefined) return
    let data = await instance({
      method:'post',
      url:'https://service.agent.pro.caixuetang.cn?v=user&a=h5goodsinfo&c=goods&site=goods&serviceversion=v1',
      data:{
        member_id: localStorage.getItem('member_id'),key: localStorage.getItem('key'),client_type:'h5',
        object_type: '11',
        object_id: '1309',
        sku_id,
        appcode: sessionStorage.getItem('appCode')
      }
    })
    if (data.code !== 1) {
      Toast.fail(data.message, 1)
      return
    }
    return data.data
  }, [member_id])
}
// 支付接口
function usePaymentFun(member_id, checkedPay, getGoodsInfo, getServicestoken,) {
  return useCallback(async () => {
    if(!member_id){
      // 这里调用登录
      Toast.fail('没有登录信息', 1)
      throw new Error('没有登录信息')
    }
    Toast.loading('加载中...', 0);
    // 获取servicestoken 获取商品信息和创建订单需要用到
    let {servicestoken} = await getServicestoken()
    // 获取商品信息
    let Info = await getGoodsInfo(servicestoken)
    let Data = Info.sku_list
    // 如果是WXGZ 则直接返回参数在跳转页使用
    if(checkedPay === PAY.WXGZ) {
      return {
        member_id: member_id,
        goods_id: Info.goods_id,
        sku_id: Data[0].goods_sku_id,
        object_type:Info.object_type,
        is_deduction: '0',
        channel:'h5',
        appId:'h5',
        channel_new: sessionStorage.getItem('channel'),
        appcode: sessionStorage.getItem('appCode')
      }
    }
    // 创建订单 获取 pay_sn
    console.log(this.props)
    const pay_snData = await instance({
      method:'post',
      url:'https://service.agent.pro.caixuetang.cn?c=buy&a=creatorder&v=user&site=pay',
      data:{
        member_id: localStorage.getItem('member_id'),key: localStorage.getItem('key'),client_type:'h5',
        goods_id: Info.goods_id,
        sku_id: Data[0].goods_sku_id,
        object_type:Info.object_type,
        is_deduction: '0',
        channel:'h5',
        appId:'h5',
        channel_new: sessionStorage.getItem('channel'),
        appcode: sessionStorage.getItem('appCode')
      }
    })
    if(pay_snData.code !== 1){
      Toast.fail(pay_snData.message,1)
      throw new Error(pay_snData.message)
    }
    // 确定支付接口
    const payFrom =  await instance({
      method: 'post',
      url: 'https://service.agent.pro.caixuetang.cn?c=Payment&a=pay&v=user&site=pay',
      data:{
        channel:'h5',
        payment_code:checkedPay,
        mchid_type:1,
        member_id: localStorage.getItem('member_id'),key: localStorage.getItem('key'),client_type:'h5',
        result_url: 'https://actdev.caixuetang.cn/act1033/#/result?member_id=' + member_id,
        pay_sn: pay_snData.data.pay_sn,
        appcode: sessionStorage.getItem('appCode')
      }
    })
    if(payFrom.code !== 1) {
      Toast.fail(payFrom.message,1)
      throw new Error(payFrom.message)
    }
    Toast.hide()
    return payFrom.data
  },[member_id, checkedPay, getGoodsInfo, getServicestoken])
}
function usePay(member_id, sku_id, checkedPay, isinner) {
  let route = useHistory()
  let getServicestoken = useGetServicestoken(member_id)
  let getGoodsInfo = useGetGoodsInfo(member_id, sku_id)
  let paymentFun = usePaymentFun(member_id, checkedPay, getGoodsInfo, getServicestoken)
  return useCallback(async () => {
    if (checkedPay === PAY.ZFB) {
      try {
        return await paymentFun()
      } catch (error) {
        console.error(error)
      }
    } else if (checkedPay === PAY.WX) {
      if (isinner) {
        // let {data} = await paymentFun()
        // route.replace({pathname: "/wxpay", search: `stat=1&apple=${data.apple}&nonceStr=${data.nonceStr}&package=${data.package}&signType=${data.apple}`})
      } else {
        try {
          let data = await paymentFun()

          // 跳转微信外部中间页
          sessionStorage.setItem('count',1);
          const retrunUrl = encodeURIComponent(`${window.location.origin}/act1033/index.html#/Wxoitpay`)
          window.location.href = `${data.mweb_url}&redirect_url=${retrunUrl}`
          route.replace({pathname: '/Wxoitpay',search:`${data.mweb_url}&redirect_url=${retrunUrl}`});
        } catch (error) {
          console.error(error)
        }
      }
    } else if (checkedPay === PAY.WXGZ) {
      let {member_id, goods_id, sku_id, object_type, is_deduction, channel, appId, channel_new, appcode} = await paymentFun()
      route.replace({pathname: "/wxpay", search: `stat=1&member_id=${member_id}&sku_id=${sku_id}&object_type=${object_type}&goods_id=${goods_id}&is_deduction=${is_deduction}&channel=${channel}&channel_new=${channel_new}&appId=${appId}&appcode=${appcode}`})
      // route.replace({pathname: "/wxpay", search: `stat=1`})
    }
  }, [isinner, route, paymentFun, checkedPay])
}
export default (props) => {
  // 获取参数
  const [member_id, setMember_id] = useState(props.member_id)// 用户ID
  const checkedPay = props.checkedPay // 支付选择
  const [DOMNode, setDOMNode] = useState('') // 支付表单
  const fromPay = useRef(null) // 支付表单
  const [bottom, setBottom] = useState('') // 支付组件的下边距
  // 获取帐号ID
  useEffect(() => {
    setMember_id(props.member_id)
    let c = computePX(375, window.innerWidth)
    setBottom(c(50))
  },[props.member_id,bottom])
  let isinner = iswx() || iszfb()
  // 微信选择时判断是否为微信内部
  const checked =  (iswx()&&checkedPay===PAY.WX) ? PAY.WXGZ : checkedPay
  let payFunc = usePay(member_id, props.sku_id, checked, isinner)
  // 获取支付表单
  useEffect(()=> {
    const payNode = fromPay.current.getElementsByTagName('form')[0]
    if(payNode === undefined) return
    payNode.submit()
    props.changeVisible(false)
  },[DOMNode, props])
  // 暴露给父组件方法
  useImperativeHandle(props.cRef, () => ({
    payFun:async () => {
      let data = await payFunc();
      // 支付宝支付
      if (checkedPay === PAY.ZFB && data) {
        setDOMNode(data.end_sign)
      }
    }
  }))
  return (
      <div className={style.OderInfo} style={{paddingBottom:bottom+'px'}}>
        <div ref={fromPay} className="asdfg" dangerouslySetInnerHTML={{__html: DOMNode}}></div>
        <div>
          <div className={style.payMentBox}>
            <PayItem name="微信" img={WX} checked={checkedPay === PAY.WX? true:false} onClick={(e)=>{props.checkeFun(PAY.WX)}} />
            <PayItem name="支付宝" img={ZFB} checked={checkedPay === PAY.ZFB? true:false} onClick={(e)=>{props.checkeFun(PAY.ZFB)}} />
          </div>
        </div>
      </div>
  )
}
